import React from "react";

import "./newcategoryform.css";
const NewCategoryForm = (props) => {
  return (
    <form onSubmit={props.handleSubmit}>
      <div className="container">
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="name">Name</label>
            <input
              name="name"
              type="text"
              className="form-control"
              id="name"
              onChange={props.onEdit}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="categoryId">Category ID (slug)</label>
            <input
              name="categoryId"
              type="text"
              className="form-control"
              id="categoryId"
              placeholder="e.g. hair_treatment"
              onChange={props.onEdit}
              required
            />
            <small className="form-text text-muted">
              Lowercase letters, numbers and underscores only. e.g. hair_cut
            </small>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row second_section">
          <div className="clo-sm-6">
            <div className="profileimage">{props.htmlElement}</div>
          </div>

          <div className="col-sm-6 btn_section">
            <label htmlFor="files" className="selectimage">
              Upload Image
            </label>
            <input
              name="avatarimage"
              id="files"
              type="file"
              onChange={props.onImageChange}
            />
            <button
              type="button"
              className="removebutton"
              onClick={props.onImageRemove}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
      <button className="btn btn-success savebtn" type="submit">
        Save
      </button>
    </form>
  );
};

export default NewCategoryForm;
